<template>
    <div class="homepage-wrapper" dir="rtl">
        <!-- 1. Navbar (شريط تنقل رسمي) -->
        <nav class="navbar navbar-expand-lg navbar-dark bg-primary-gradient fixed-top shadow-sm">
            <div class="container">
                <a class="navbar-brand fw-bold d-flex align-items-center" href="#">
                    <img :src="'/img/logo/edu.png'" alt="Logo" class="nav-logo me-2 bg-white rounded-circle p-1" width="40" height="40" v-if="true">
                    <div class="d-flex flex-column me-2">
                        <span class="brand-text fs-6">مديرية التربية والتعليم</span>
                        <span class="brand-subtext fs-7 text-gold">لجنة النظام والمراقبة - الشهادة الإعدادية</span>
                    </div>
                </a>
             <button 
          class="navbar-toggler" 
          type="button" 
          @click="toggleMenu" 
          :aria-expanded="isMenuOpen"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

  <!-- 1. أضفنا ref="navbarMenu" هنا -->
 <div class="collapse navbar-collapse" :class="{ 'show': isMenuOpen }" id="navbarNav">
          <ul class="navbar-nav mx-auto">
            <li class="nav-item"><a class="nav-link" href="#" @click="closeMenu">الرئيسية</a></li>
            <li class="nav-item"><a class="nav-link" href="#services" @click="closeMenu">الخدمات الإلكترونية</a></li>
            <li class="nav-item"><a class="nav-link" href="#stats" @click="closeMenu">إحصائيات</a></li>
            <li class="nav-item"><a class="nav-link" href="#news" @click="closeMenu">أخبار الكنترول</a></li>
          </ul>
          
          <div class="d-flex gap-2">


    <router-link :to="isLoggedIn ? dashboardRoute : { name: 'Login' }" class="btn btn-primary btn-lg px-5 rounded-1 shadow-lg">
                        <i :class="isLoggedIn ? 'fas fa-tachometer-alt' : 'fas fa-user-tie'" class="me-2"></i>
                        {{ isLoggedIn ? 'الذهاب للوحة التحكم' : 'تسجيل الدخول' }}
                    </router-link>


            <!-- <router-link 
             :to="isLoggedIn ? dashboardRoute : { name: 'Login' }"
              class="btn btn-gold btn-sm px-4 fw-bold rounded-1"
              @click.native="closeMenu"
            >
              <i class="fas fa-lock me-2"></i>دخول المدارس
            </router-link> -->
          </div>
        </div>
    
    
            </div>
        </nav>

        <!-- 2. Hero Section (الواجهة الرئيسية) -->
        <header class="hero-section d-flex align-items-center justify-content-center text-center text-white">
            <div class="hero-overlay"></div>
            <div class="hero-particles"></div>
            <div class="container hero-content position-relative" data-aos="fade-up">
                <div class="mb-4">
                    <i class="fas fa-university fa-3x text-gold mb-3"></i>
                </div>
                <h1 class="display-4 fw-bolder mb-2 title-shadow">المنظومة الرقمية لإدارة الامتحانات</h1>
                <h2 class="h4 text-light opacity-75 mb-5">كنترول الشهادة الإعدادية شمال سيناء - الفصل الدراسي الأول 2026</h2>
                
                <div class="d-flex justify-content-center gap-3 flex-wrap">


                    <div v-if="systemStatus.is_seating_numbers_active">
                 <a   href="SeatingInquiry" class="btn btn-outline-light btn-lg px-5 rounded-1">
                        <i class="fas fa-search me-2"></i>الاستعلام عن رقم الجلوس
                    </a>
                    </div>
            
                    <div v-else class="alert alert-secondary">
                    خدمة أرقام الجلوس تفتح قريباً
                    </div>

                    <div v-if="systemStatus.is_appeals_active">
                 <a   href="AppealsRequest" class="btn btn-outline-light btn-lg px-5 rounded-1">
                        <i class="fas fa-search me-2"></i> طلب مراجعة أوراق الإجابة
                    </a>
                    </div>
                    <div v-else class="alert alert-secondary">
                    خدمة  طلب مراجعة أوراق الإجابة تفتح قريباً
                    </div>






<!--                     
                    <a href="AppealsRequest" class="btn btn-outline-light btn-lg px-5 rounded-1">
                        <i class="fas fa-search me-2"></i>   طلب مراجعة أوراق الإجابة
                    </a> -->
                  <!-- <router-link :to="isLoggedIn ? dashboardRoute : { name: 'Login' }" class="btn btn-primary btn-lg px-5 rounded-1 shadow-lg">
                        <i :class="isLoggedIn ? 'fas fa-tachometer-alt' : 'fas fa-user-tie'" class="me-2"></i>
                        {{ isLoggedIn ? 'الذهاب للوحة التحكم' : 'تسجيل الدخول' }}
                    </router-link> -->
                </div>
            </div>
        </header>

        <!-- 3. Tribute Section (قسم التكريم - خاص جداً) -->
        <!-- تم تصميمه ليكون فاصل مميز بين الهيدر والمحتوى -->
        <div class="tribute-bar py-5">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-10" data-aos="zoom-in">
                        <div class="tribute-content text-center p-4 rounded-3 position-relative">
                            <div class="quote-icon"><i class="fas fa-quote-right"></i></div>
                            <h5 class="text-white-50 mb-2 fw-light">كلمة حق ووفاء</h5>
                            <h3 class="text-white fw-bold mb-3">
                                انطلقت هذه المنظومة الرقمية وتطورت برؤية ثاقبة وتوجيهات سديدة
                            </h3>
                            <div class="name-badge d-inline-block px-5 py-2 mt-2 mb-3">
                                <h2 class="text-gold fw-bolder m-0">للسيد الأستاذ / حمزة أمين رضوان</h2>
                            </div>
                            <p class="text-light fs-5 mb-0">صاحب الفكر المتطور والنقلة النوعية في ميكنة أعمال الامتحانات والكنترول</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 4. Services Section (الخدمات) -->
        <section id="services" class="py-5 bg-light">
            <div class="container">
                <div class="section-header text-center mb-5" data-aos="fade-up">
                    <h5 class="text-primary fw-bold">الخدمات الإلكترونية</h5>
                    <h2 class="fw-bolder text-dark">ما تقدمه المنظومة</h2>
                    <div class="divider mx-auto bg-primary"></div>
                </div>

                <div class="row g-4">
                    <!-- Service 1 -->
                    <div class="col-md-3" data-aos="fade-up" data-aos-delay="100">
                        <div class="service-card h-100 bg-white p-4 rounded-3 shadow-sm border-bottom-primary">
                            <div class="icon-box bg-primary-light text-primary mb-4">
                                <i class="fas fa-id-card-alt fa-2x"></i>
                            </div>
                            <h4 class="fw-bold mb-3">أرقام الجلوس</h4>
                            <p class="text-muted">إتاحة الاستعلام عن أرقام الجلوس ولجان الاختبارات للطلاب وتوزيع اللجان على المدارس إلكترونياً.</p>
                  <div v-if="systemStatus.is_seating_numbers_active">
                 <a   href="SeatingInquiry" class="btn btn-outline-dark btn-lg px-5 rounded-1">
                        <i class="fas fa-search me-2"></i>الاستعلام عن رقم الجلوس
                    </a>
                    </div>
            
                    <div v-else class="alert alert-secondary">
                    خدمة أرقام الجلوس تفتح قريباً
                    </div>
                        </div>
                    </div>

                    <!-- Service 2 -->
                    <div class="col-md-3" data-aos="fade-up" data-aos-delay="200">
                        <div class="service-card h-100 bg-white p-4 rounded-3 shadow-sm border-bottom-success">
                            <div class="icon-box bg-success-light text-success mb-4">
                                <i class="fas fa-poll-h fa-2x"></i>
                            </div>
                            <h4 class="fw-bold mb-3">رصد الدرجات</h4>
                            <p class="text-muted">منظومة متكاملة لرصد درجات أعمال السنة والأنشطة .</p>
                        </div>
                    </div>
                    <div class="col-md-3" data-aos="fade-up" data-aos-delay="200">
                        <div class="service-card h-100 bg-white p-4 rounded-3 shadow-sm border-bottom-success">
                            <div class="icon-box bg-success-light text-success mb-4">
                                <i class="fas fa-poll-h fa-2x"></i>
                            </div>
                            <h4 class="fw-bold mb-3">خدمة التظلمات الإلكترونية</h4>
                            <p class="text-muted">تتيح المديرية خدمة التظلم الإلكتروني على نتائج الامتحانات</p>

                    <div v-if="systemStatus.is_appeals_active">
                 <a   href="AppealsRequest" class="btn btn-outline-dark btn-lg px-5 rounded-1">
                        <i class="fas fa-search me-2"></i> طلب مراجعة أوراق الإجابة
                    </a>
                    </div>
                    <div v-else class="alert alert-secondary">
                    خدمة  طلب مراجعة أوراق الإجابة تفتح قريباً
                    </div>
                        </div>
                    </div>

                    <!-- Service 3 -->
                    <div class="col-md-3" data-aos="fade-up" data-aos-delay="300">
                        <div class="service-card h-100 bg-white p-4 rounded-3 shadow-sm border-bottom-warning">
                            <div class="icon-box bg-warning-light text-warning mb-4">
                                <i class="fas fa-chart-line fa-2x"></i>
                            </div>
                            <h4 class="fw-bold mb-3">النتائج والإحصاءات</h4>
                            <p class="text-muted">إعلان النتائج النهائية وتحليل الإحصاءات العامة للمحافظة والمدارس وترتيب الطلاب.</p>
                                     <div v-if="systemStatus.is_results_active">
                 <a   href="ResultPortal" class="btn btn-outline-dark btn-lg px-5 rounded-1">
                        <i class="fas fa-search me-2"></i>الاستعلام عن النتيجة
                    </a>
                    </div>
                          <div v-else class="alert alert-secondary">
                  غير متاحة حالياً
                    </div>
                       
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 5. Stats Counter (الإحصائيات) -->
        <section id="stats" class="stats-section py-5 text-white">
            <div class="container position-relative z-2">
                <div class="row text-center">
                    <div class="col-md-3 col-6 mb-4" data-aos="fade-up">
                        <i class="fas fa-school fa-3x text-gold mb-3"></i>
                        <h2 class="display-4 fw-bold">{{ animatedStats.schools }}</h2>
                        <p class="lead">مدرسة إعدادية</p>
                    </div>
                    <div class="col-md-3 col-6 mb-4" data-aos="fade-up" data-aos-delay="100">
                        <i class="fas fa-user-graduate fa-3x text-gold mb-3"></i>
                        <h2 class="display-4 fw-bold">{{ animatedStats.students.toLocaleString() }}</h2>
                        <p class="lead">طالب وطالبة</p>
                    </div>
                    <div class="col-md-3 col-6 mb-4" data-aos="fade-up" data-aos-delay="200">
                        <i class="fas fa-building fa-3x text-gold mb-3"></i>
                        <h2 class="display-4 fw-bold">{{ animatedStats.committees }}</h2>
                        <p class="lead">لجنة سير</p>
                    </div>
                    <div class="col-md-3 col-6 mb-4" data-aos="fade-up" data-aos-delay="300">
                        <i class="fas fa-file-alt fa-3x text-gold mb-3"></i>
                        <h2 class="display-4 fw-bold">{{ animatedStats.papers.toLocaleString() }}</h2>
                        <p class="lead">ورقة إجابة</p>
                    </div>
                </div>
            </div>
            <div class="stats-overlay"></div>
        </section>

        <!-- 6. Footer -->
        <footer class="bg-dark text-white pt-5 pb-3 border-top border-3 border-primary">
            <div class="container text-center text-md-end">
                <div class="row">
                    <div class="col-md-4 mx-auto mt-3">
                        <h5 class="text-uppercase mb-4 fw-bold text-primary">كنترول الشهادة الإعدادية</h5>
                        <p class="small text-white-50">
                            نظام إلكتروني موحد لإدارة أعمال الامتحانات والكنترول، يهدف إلى تحقيق الدقة والسرعة والشفافية في رصد الدرجات وإعلان النتائج.
                        </p>
                    </div>
                    <div class="col-md-4 mx-auto mt-3">
                        <h5 class="text-uppercase mb-4 fw-bold">الدعم الفني</h5>
                        <p><i class="fas fa-headset me-2 text-gold"></i>فريق كنترول الشهادة اﻻعدادية</p>
                        <!-- <p><i class="fas fa-envelope me-2 text-gold"></i>support@control-system.edu</p> -->
                    </div>
                </div>
                <hr class="my-4 border-secondary">
                <div class="text-center small">
                    <p>جميع الحقوق محفوظة © {{ new Date().getFullYear() }} - لجنة النظام والمراقبة</p>
                    <p class="text-white-50">تم التطوير برعاية وتوجيهات السيد الأستاذ / حمزة أمين رضوان</p>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import { Collapse } from 'bootstrap'; 
import api from '@/api/axios';
// import api from '../api/axios'; // فعل هذا السطر عند الربط
export default {
    name: 'HomePage',
    data() {
        return {
             isMenuOpen: false,
            isLoggedIn:false,
            userRole:null,
                   systemStatus: {
          seating: false,
          appeals: false,
          results: false
        },
            animatedStats: {
                schools: 0,
                students: 0,
                committees: 0,
                papers: 0
            },
            // القيم النهائية المستهدفة (يمكن جلبها من الـ API)
            targetStats: {
                schools: 250,      // مثال: عدد المدارس
                students: 35000,   // مثال: عدد الطلاب
                committees: 120,   // مثال: عدد اللجان
                papers: 175000     // مثال: أوراق الإجابة
            },
             observer: null, // لمراقبة السكرول
            hasAnimated: false // لضمان عدم تكرار الأنيميشن
        };
    },
      computed: {
        // تحديد مسار لوحة التحكم بناءً على الدور
        dashboardRoute() {
            if (this.userRole === 'admin') return { name: 'AdminComplaintsDashboard' };
            if (this.userRole === 'school_manager') return { name: 'SchoolManagerInstructions' }; // أو صفحة المدرسة الرئيسية
            if (this.userRole === 'committee_head') return { name: 'CommitteeCommunication' };
            if (this.userRole === 'control_member') return { name: 'StudentAbs' };
            if (this.userRole === 'control_head') return { name: 'StudentInquiryOn' };
            if (this.userRole === 'operations_admin') return { name: 'Statistics' };
            return { name: 'Login' }; // افتراضي
        }
    },
    mounted() {
        // this.animateCounters();
        this.fetchStats();
          this.checkLoginStatus();
                api.get('/public/system-status').then(res => {
    this.systemStatus = res.data;
  });
    },
     beforeDestroy() {
        // تنظيف المراقب عند الخروج
        if (this.observer) this.observer.disconnect();
    },
    methods: {
         checkLoginStatus() {

            const token = localStorage.getItem('auth_token'); // أو اسم مفتاح التوكن عندك
            const user = localStorage.getItem('user'); // بيانات المستخدم
            
            if (token && user) {
                this.isLoggedIn = true;
                this.userRole = JSON.parse(user).role; // تأكد أن التخزين عندك JSON
            } else {
                this.isLoggedIn = false;
                this.userRole = null;
            }
        },
 toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },

    // دالة الإغلاق (للروابط)
    closeMenu() {
      this.isMenuOpen = false;
    },
     async fetchStats() {
            try {
                const res = await api.get('/public/home-stats');
                this.targetStats = res.data;
                
                // 2. بعد وصول البيانات، نبدأ مراقبة السكشن
                // لن يبدأ العد إلا عندما يظهر السكشن على الشاشة
                this.initObserver();

            } catch (error) {
                console.error("Error fetching stats", error);
                // قيم افتراضية في حالة الخطأ
                this.targetStats = { schools: 150, students: 35000, committees: 120, papers: 175000 };
                this.initObserver();
            }
        },

        initObserver() {
            // نحدد العنصر الذي يحتوي الإحصائيات
            const section = document.querySelector('#stats');
            
            if (!section) return; // حماية

            this.observer = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && !this.hasAnimated) {
                    this.hasAnimated = true; // منع التكرار
                    this.startAnimation();   // ابدأ العد الآن
                }
            }, { threshold: 0.5 }); // يبدأ عندما يظهر 50% من السكشن

            this.observer.observe(section);
        },

        startAnimation() {
            // تشغيل الأنيميشن لكل عنصر بمعادلة رياضية ثابتة ومستقرة
            this.animateValue('schools', this.targetStats.schools, 2000);
            this.animateValue('students', this.targetStats.students, 2500);
            this.animateValue('committees', this.targetStats.committees, 2000);
            this.animateValue('papers', this.targetStats.papers, 3000);
        },

        animateValue(key, end, duration) {
            if (end === 0) return;
            
            let start = 0;
            const frameDuration = 1000 / 60; // 60 فريم في الثانية (حوالي 16ms)
            const totalFrames = Math.round(duration / frameDuration);
            const easeOutQuad = t => t * (2 - t); // دالة لجعل الحركة ناعمة (سريع ثم يبطئ)

            let frame = 0;
            
            const counter = setInterval(() => {
                frame++;
                
                // حساب نسبة التقدم (0.0 إلى 1.0)
                const progress = easeOutQuad(frame / totalFrames);
                
                // حساب القيمة الحالية
                const current = Math.round(end * progress);

                if (frame === totalFrames) {
                    this.animatedStats[key] = end; // ضمان الوصول للرقم النهائي بدقة
                    clearInterval(counter);
                } else {
                    this.animatedStats[key] = current;
                }
            }, frameDuration);
        },
    },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700;900&display=swap');

.homepage-wrapper {
    font-family: 'Cairo', sans-serif;
    background-color: #f8f9fa;
    overflow-x: hidden;
}

/* --- Colors & Variables --- */
:root {
    --primary-color: #0d47a1; /* أزرق داكن رسمي */
    --gold-color: #ffc107;
    --dark-blue: #002147;
}

.text-gold { color: #ffc107 !important; }
.bg-primary-gradient {
    background: linear-gradient(90deg, #002147 0%, #0d47a1 100%);
}
.btn-gold {
    background-color: #ffc107;
    color: #002147;
    border: none;
    transition: all 0.3s;
}
.btn-gold:hover {
    background-color: #e0a800;
    transform: translateY(-2px);
}

/* --- Navbar --- */
.navbar-brand .brand-text { font-weight: 700; color: white; }
.navbar-brand .brand-subtext { font-size: 0.75rem; display: block; }
.nav-link { color: rgba(255,255,255,0.8) !important; font-weight: 600; transition: color 0.3s; }
.nav-link:hover, .nav-link.active { color: #ffc107 !important; }

/* --- Hero Section --- */
.hero-section {
    position: relative;
    height: 90vh;
    min-height: 600px;
    /* background: url('/img/logo/bg-control.jpg') no-repeat center center fixed;  */
    margin-top: 60px; /* لتعويض الـ navbar fixed */
}

.hero-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(0, 33, 71, 0.9) 0%, rgba(13, 71, 161, 0.8) 100%);
}

.title-shadow { text-shadow: 2px 2px 4px rgba(0,0,0,0.5); }

/* --- Tribute Section (التكريم) --- */
.tribute-bar {
    background: #00152e; /* لون داكن جداً للفخامة */
    margin-top: -50px; /* تداخل مع الهيرو */
    position: relative;
    z-index: 10;
    border-bottom: 4px solid #ffc107;
    box-shadow: 0 10px 30px rgba(0,0,0,0.3);
}

.tribute-content {
    background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}

.quote-icon {
    font-size: 2rem;
    color: #ffc107;
    margin-bottom: 10px;
    opacity: 0.5;
}

.name-badge {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 193, 7, 0.3);
    border-radius: 8px;
}

/* --- Services Cards --- */
.service-card {
    transition: transform 0.3s, box-shadow 0.3s;
    border: 1px solid #eee;
}
.service-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 30px rgba(0,0,0,0.1);
}
.icon-box {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
}
.bg-primary-light { background-color: rgba(13, 71, 161, 0.1); }
.bg-success-light { background-color: rgba(25, 135, 84, 0.1); }
.bg-warning-light { background-color: rgba(255, 193, 7, 0.1); }

.border-bottom-primary { border-bottom: 4px solid #0d47a1 !important; }
.border-bottom-success { border-bottom: 4px solid #198754 !important; }
.border-bottom-warning { border-bottom: 4px solid #ffc107 !important; }

/* --- Stats Section --- */
.stats-section {
    position: relative;
    background: #0d47a1;
    background-attachment: fixed;
}
.stats-overlay {
    position: absolute;
    inset: 0;
    /* background: url('/img/pattern.png');  */
    opacity: 0.1;
}

/* --- Divider --- */
.divider {
    width: 60px;
    height: 4px;
    border-radius: 2px;
    margin-top: 15px;
}
</style>